const btn1 = document.querySelector("#btn1");
                const btn2 = document.querySelector("#btn2");
                const xx1 = document.querySelector("#bundle_1");
                const xx2 = document.querySelector("#bundle_2");

                // Default: btn1 active
                updateBoxes(1);

                btn1.addEventListener("click", () => {
                  btn1.classList.add("active");
                  btn2.classList.remove("active");
                  updateBoxes(1);
                });

                btn2.addEventListener("click", () => {
                  btn2.classList.add("active");
                  btn1.classList.remove("active");
                  updateBoxes(2);
                });

                function updateBoxes(num) {
                  if (num === 1) {
                    xx1.classList.add("active");
                    xx2.classList.remove("active");
                  } else {
                    xx2.classList.add("active");
                    xx1.classList.remove("active");
                  }
                }
